import { combineReducers } from "redux";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { customViewsReducer } from "store/entities/custom-views/reducer";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { mailboxesReducer } from "store/entities/mailboxes/reducer";
import { KeyMap } from "utils/interface";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { agentsReducer } from "./agents";
import { applicationSettingsReducer } from "./application-settings/reducer";
import { applicationsReducer } from "./applications";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { billingReducer } from "./billing";
import { cannedResponsesReducer } from "./canned-responses";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { contactFormsReducer } from "./contact-forms/reducer";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { customFieldsReducer } from "./custom-fields/reducer";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { emailDomainsReducer } from "./email-domains";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { emailTemplatesReducer } from "./email-template/reducer";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { integrationsReducer } from "./integrations";
import { licenseReducer } from "./license";
import recurlyReducer from "./recurly/reducer";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import replyAddressesReducer from "./reply-addresses/reducer";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { rulesReducer } from "./rules/reducer";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { spamReducer } from "./spam/reducer";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { subscriptionsReducer } from "./subscriptions";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { tagsReducer } from "./tags";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { teamsReducer } from "./teams";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { transactionsReducer } from "./transaction/reducer";

// eslint-disable-next-line @typescript-eslint/no-empty-interface, @typescript-eslint/no-empty-object-type
export interface IEntityCollectionState<TEntity> extends KeyMap<TEntity> {}

const entitiesReducer = combineReducers({
  agents: agentsReducer,
  applications: applicationsReducer,
  billing: billingReducer,
  cannedResponses: cannedResponsesReducer,
  emailDomains: emailDomainsReducer,
  integrations: integrationsReducer,
  recurly: recurlyReducer,
  tags: tagsReducer,
  teams: teamsReducer,
  customViews: customViewsReducer,
  license: licenseReducer,
  mailboxes: mailboxesReducer,
  subscriptions: subscriptionsReducer,
  transactions: transactionsReducer,
  replyAddresses: replyAddressesReducer,
  contactForms: contactFormsReducer,
  emailTemplates: emailTemplatesReducer,
  rules: rulesReducer,
  spam: spamReducer,
  customFields: customFieldsReducer,
  applicationSettings: applicationSettingsReducer,
});

export type EntitiesState = ReturnType<typeof entitiesReducer>;

export default entitiesReducer;
